import styled, { css } from 'styled-components';
import { fontUi, sectionTitle } from '../../theme/typography';

export const StyledPagination = styled.section`
  margin: 10px 0;
`;

export const StyledTable = styled.table`
  width: 100%;
  height: 100%;
  flex: 1;
  table-layout: fixed;
  border-collapse: collapse;
  border-style: hidden;
`;

export const StyledTrTd = styled.tr`
  background: transparent;
  height: 20%;
  ${({ active, theme }) => {
    if (active) {
      return css`
        background: ${theme.isDark
          ? 'rgba(14, 74, 251, 0.24)'
          : 'rgba(14, 74, 251, 0.12)'};
        pointer-events: none;
      `;
    }
  }};
`;

export const StyledTd = styled.td`
  ${fontUi};
  padding: 8px 6px;
  font-weight: 500;
  font-size: 13px;
  line-height: 1.3;
  color: ${({ theme }) => theme.textMuted};
  vertical-align: middle;
  ${({ $kind }) => {
    if ($kind === 'round') {
      return css`
        width: auto;
        text-align: left;
        padding-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      `;
    }
    if ($kind === 'date') {
      return css`
        width: 7.25rem;
        text-align: right;
        white-space: nowrap;
        font-variant-numeric: tabular-nums;
      `;
    }
    if ($kind === 'status') {
      return css`
        width: 14px;
        padding: 8px 10px 8px 4px;
        text-align: right;
      `;
    }
  }}
`;

export const StyledContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  padding: 16px 12px 8px;
  box-sizing: border-box;
  overflow: hidden;
`;

export const StyledTableContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  overflow: hidden;
  padding-bottom: 4px;
`;

export const StyledTbody = styled.tbody`
  height: 100%;
`;

export const StyledSubheader = styled.span`
  ${fontUi};
  display: block;
  color: ${({ theme }) => theme.textFaint};
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1.17px;
  padding: 0 4px;
`;

export const StyledHeader = styled.h3`
  ${sectionTitle};
  font-size: 18px;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  margin: 6px 0 8px;
  padding: 0 4px 12px;
`;

export const StyledStatusIcon = styled.span`
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  vertical-align: middle;
  background-color: ${({ theme, $upcoming }) =>
    $upcoming ? theme.textFaint : theme.success};
`;
